import { FC, useEffect } from 'react';
import { useHistory } from 'react-router';
import * as Meta from 'meta';

import { Header, Footer } from "components";
import { getResult } from 'utils';
import { ROUTE } from 'route';

export const AnimaPage: FC = () => {
  const history = useHistory();
  useEffect(() => {
    setTimeout(() => {
      if(getResult() === "win") history.push(ROUTE.YOUWIN);
      if(getResult() === "lose") history.push(ROUTE.YOULOSE);
    }, 2000);
  }, []);

  return (
    <div className="wrapper" data-testid="動畫頁">
      {Meta.loadCSS(["anima", "notice"])}
      {Meta.loadJS(["main-0625"])}
      <Header />
      <div className="main">
        <section className="anima">
          <img src="/resources/html/images/05.gif" />
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
